module.exports = __webpack_public_path__ + "static/img/background.22070ba6.png";